import { createStyles, Theme } from '@material-ui/core/styles'

export default (theme: Theme) =>
	createStyles({
		form: {
			marginBottom: 'auto',
			display: 'flex',
			flexDirection: 'column',
		},
		container: {
			marginBottom: 'auto',
			display: 'flex',
			flexDirection: 'column',
			alignItems: 'center',
			'&>div:nth-child(2)': {
				marginTop: 0,
			},
		},
		loginButton: {
			flex: 1,
			alignSelf: 'stretch',
			padding: '15px 0',
			fontSize: 18,
			color: 'rgba(255, 255, 255, 0.3)',
			background: 'rgba(0,0,0,0.1)',
			marginTop: 16,
		},
		loginButtonActive: {
			background: theme.palette.action.active,
			color: 'rgba(255, 255, 255, 1)',
		},
		forgotPasswordLink: {
			color: 'rgba(255, 255, 255, 0.6)',
			alignSelf: 'flex-end',
		},
		authDelimiter: {
			flex: 1,
			alignSelf: 'stretch',
			textAlign: 'center',
			position: 'relative',
			display: 'flex',
			flexDirection: 'row',
			alignItems: 'center',
			justifyContent: 'space-evenly',
			margin: `${theme.spacing(1)}px 0`,
			'& > hr': {
				flex: 1,
				borderColor: 'rgba(255, 255, 255, 0.05)',
			},
			'& > span': {
				flex: 0.3,
				fontWeight: 300,
				fontStyle: 'italic',
				color: 'rgba(255, 255, 255, 0.2)',
			},
		},
		socialLinks: {
			display: 'flex',
			flexDirection: 'row',
			alignItems: 'center',
			justifyContent: 'center',
			'& svg': {
				width: 32,
				height: 32,
				margin: 0,
				'& path': {
					fill: 'rgba(255, 255, 255, 0.6)',
				},
			},
		},
		createAccount: {
			display: 'flex',
			flexDirection: 'row',
			alignItems: 'flex-end',
			marginBottom: theme.spacing(2),
			'& > span': {
				fontSize: 14,
				fontWeight: 300,
				lineHeight: '20px',
				color: 'rgba(255, 255, 255, 0.4)',
			},
			'& > button': {
				fontSize: 16,
				fontWeight: 300,
				lineHeight: '20px',
				marginLeft: theme.spacing(0.5),
				color: 'rgba(255, 255, 255, 1)',
			},
		},
		errorMessagesContainer: {
			// marginBottom: 'auto',
			marginBottom: 15,
		},
		capslockWarning: {
			color: '#ffffff',
			textTransform: 'lowercase',
			fontSize: 18,
			fontWeight: 700,
			'& > svg': {
				height: 18,
				position: 'relative',
				top: 6,
				fill: '#ffffff',
			},
		},
		accountConfirmation: {
			whiteSpace: 'pre-line',
			textTransform: 'inherit',
			color: 'rgba(255, 255, 255, 0.85)',
			fontSize: 18,
			fontWeight: 700,
			display: 'flex',
			justifyContent: 'center',
			[theme.breakpoints.down('xs')]: {
				marginLeft: theme.spacing(2),
				marginRight: theme.spacing(2),
				fontSize: 14
			},
		},
		messageWithIcon: {
			display: 'flex',
			flexDirection: 'row',
			alignItems: 'center',
			justifyContent: 'center',
			'& > svg': {
				marginRight: theme.spacing(1),
				fill: 'rgba(255, 255, 255, 0.6)',
			},
		},
		loading: {
			color: 'rgba(255, 255, 255, 0.6)',
		},
	})
